import React, { useState, useCallback, useRef, useEffect } from "react";
import ReactCrop from "react-image-crop";
import "react-image-crop/dist/ReactCrop.css";
import Button from "components/CustomButton";
import { Modal } from "react-responsive-modal";

const pixelRatio = window.devicePixelRatio || 1;

const styles = {
  attachmentFile: {
    display: "none",
  },
  noBottomMargin: {
    marginBottom: "0 !important",
    padding: "20px",
  },
  orignalImageWrapper: {
    width: "100%",
    maxWidth: "450px",
  },
  actionsContainer: {
    display: "flex",
    gap: "10px",
    justifyContent: "flex-end",
    maxWidth: "450px",
  },
  flexOne: {
    flex: "1",
  },
  cancelButton: {
    background: "none",
    color: "black",
  },
};

export default ({
  children,
  aspect = 16 / 9,
  onUpdate,
  id = "avatar-image-file",
  uploadContainer,
}) => {
  const classes = styles;

  const imgRef = useRef(null);
  const previewCanvasRef = useRef(null);
  const attachmentInputRef = useRef(null);

  const [isOpen, setIsOpen] = useState(false);
  const [imageSrc, setImageSrc] = useState(false);
  const [completedCrop, setCompletedCrop] = useState(null);
  const [acceptedMimeTypes] = useState([".png", ".jpg", ".jpeg"]);
  const [crop, setCrop] = useState({ unit: "%", width: 50, aspect });

  useEffect(() => {
    if (!completedCrop || !previewCanvasRef.current || !imgRef.current) {
      return;
    }

    const image = imgRef.current;
    const canvas = previewCanvasRef.current;
    const crop = completedCrop;

    const scaleX = image.naturalWidth / image.width;
    const scaleY = image.naturalHeight / image.height;
    const ctx = canvas.getContext("2d");

    canvas.width = crop.width * pixelRatio;
    canvas.height = crop.height * pixelRatio;

    ctx.setTransform(pixelRatio, 0, 0, pixelRatio, 0, 0);
    ctx.imageSmoothingQuality = "high";

    ctx.drawImage(
      image,
      crop.x * scaleX,
      crop.y * scaleY,
      crop.width * scaleX,
      crop.height * scaleY,
      0,
      0,
      crop.width,
      crop.height
    );
  }, [completedCrop]);

  const onAttachmentSelected = async (event) => {
    const file = event.nativeEvent.target.files[0];

    attachmentInputRef.current.value = null;

    if (!file) {
      return;
    }

    setIsOpen(true);
    setImageSrc(URL.createObjectURL(file));
  };

  const onLoad = useCallback((img) => {
    imgRef.current = img;
  }, []);

  const saveCropedImage = () => {
    const previewCanvas = previewCanvasRef.current;

    if (!crop || !previewCanvas) {
      return;
    }

    if (!completedCrop.height || !completedCrop.width) {
      return;
    }

    const canvas = getResizedCanvas(previewCanvas, crop.width, crop.height);

    canvas.toBlob(
      (blob) => {
        if (onUpdate) {
          onUpdate(blob);
          setIsOpen(false);
        }
      },
      "image/png",
      1
    );
  };

  return (
    <>
      <div className={uploadContainer ? uploadContainer : null}>
        <label htmlFor={id}>
          <input
            style={classes.attachmentFile}
            id={id}
            type="file"
            ref={attachmentInputRef}
            accept={acceptedMimeTypes.join(",")}
            onChange={onAttachmentSelected}
          />
          {children}
        </label>
      </div>
      <Modal
        closeOnEsc={false}
        closeOnOverlayClick={false}
        classNames={{ modalContainer: "modalContainer", modal: "modalPadding" }}
        open={isOpen}
        showCloseIcon={false}
        onClose={() => setIsOpen(false)}
      >
        <div style={classes.noBottomMargin}>
          <div style={classes.orignalImageWrapper}>
            <ReactCrop
              src={imageSrc}
              onImageLoaded={onLoad}
              crop={crop}
              onChange={(c) => setCrop(c)}
              onComplete={(c) => setCompletedCrop(c)}
            />
            <canvas
              ref={previewCanvasRef}
              style={{
                width: Math.round(completedCrop?.width ?? 0),
                height: Math.round(completedCrop?.height ?? 0),
                display: "none",
              }}
            />
          </div>
          <div style={classes.actionsContainer}>
            <Button
              buttonClass={"grad_btn join-btn"}
              onClick={() => setIsOpen(false)}
              buttonStyle={classes.cancelButton}
            >
              Cancel
            </Button>
            <Button
              buttonClass={"grad_btn join-btn"}
              type="submit"
              color="primary"
              onClick={saveCropedImage}
            >
              Update
            </Button>
          </div>
        </div>
      </Modal>
    </>
  );
};

function getResizedCanvas(canvas, newWidth, newHeight) {
  const tmpCanvas = document.createElement("canvas");
  tmpCanvas.width = newWidth;
  tmpCanvas.height = newHeight;

  const ctx = tmpCanvas.getContext("2d");
  ctx.drawImage(
    canvas,
    0,
    0,
    canvas.width,
    canvas.height,
    0,
    0,
    newWidth,
    newHeight
  );

  return tmpCanvas;
}
